import * as CommonModels from '../commonModels';

export class SpecificationSearchModel extends CommonModels.SearchBaseModel {

  public registrationNumber: string;
  public customerId: number;
  public selectedCustoemrs: number[];
  public invoiceId: number;
  public customer: string;
  public garageId: number;
  public garage: string;
  public number: string;
  public vin: string;
  public specificationStatusId: number;
  public date0: Date;
  public date1: Date;
  public period: any;
  public periodDateRange: CommonModels.DateRange;
  public isCustomerInvoice: boolean;
  public isServiceInvoice: boolean;
  public garageInvoiceNr: string;
  public customerInvoiceNr: string;
  public loss: boolean;
  public isMechanical: boolean;
  public hasAttachment: boolean;
  public zero: number; // 0 - Hide, 1 - Garage, 2 - Customer, 3 - Both
  public isModified: boolean;
  public linkedOrderTypeId: number; // 0 - Any, 1 - Relocation, 2 - Utylization, 3 - TyreOrder, 4 - TakeoverTyres, 5 - ReturnTyres,
  // 6 - ReRegistrationTyres, 7 - Maintenance, 8 - Repair, 9 - TyreRepair, 10 - TyreChange,
  public mark: string;
  public sum: boolean;
  public mechanic: string;
  public CarId: number;
  public HasNotes: boolean;
  public InitiallyWaitingToAccepted: boolean;
  public IsCacheUsed: boolean;
  public ExcludeSpecificationIds: number[];
  public ServiceCostTypeId: number;
  public IsServiceCostType: boolean;

  constructor(garageId?: number) {
    super();
    this.garageId = garageId || null;
    this.periodDateRange = new CommonModels.DateRange();
    this.IsCacheUsed = false;
  }
}

export class SpecificationPreviewSearchModel extends CommonModels.SearchBaseModel {
  public OrderId: number;
  public GarageId: number;
  public CarId: number;
  public IsActualContract: boolean;
  public ContractId: number;
}
